import { render, staticRenderFns } from "./EquipmentBathtube.vue?vue&type=template&id=028e1958&scoped=true"
import script from "./EquipmentBathtube.vue?vue&type=script&lang=ts"
export * from "./EquipmentBathtube.vue?vue&type=script&lang=ts"
import style0 from "./EquipmentBathtube.vue?vue&type=style&index=0&id=028e1958&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e1958",
  null
  
)

export default component.exports